// extracted by mini-css-extract-plugin
module.exports = {"container":"FormRadio_container__8mHt2","radios":"FormRadio_radios__1oggh"};